// extracted by mini-css-extract-plugin
module.exports = {"content":"_32bbee5fda--content--KKx2S","footer-buttons":"_32bbee5fda--footer-buttons--yFcCA"};